import React from 'react';
import { useDropzone } from 'react-dropzone';

const DropableComponent = ({ children, config }) => {
  const { getRootProps, getInputProps } = useDropzone(config);

  return (
    <span {...getRootProps({ className: 'dropzone' })}>
      <input {...getInputProps()} data-testid="drop-input" />
      {children}
    </span>
  )
}

export default DropableComponent;